// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"3a5fab81","950":"fb745aa1"}[chunkId] + ".chunk.js";
};